import { render, staticRenderFns } from "./ListarClassificacaoDestino.vue?vue&type=template&id=ac881e02"
import script from "./ListarClassificacaoDestino.vue?vue&type=script&lang=js"
export * from "./ListarClassificacaoDestino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports